import { useRef } from 'react'
import styled from 'styled-components'

//* =============================== Types ======================================

type TapRecognizerSegmentProps = {
  flexGrow: number
  /**
   * If only single taps are allowed.
   * When this is true, then the onDoubleTap callback will not be called.
   */
  onlySingleTap: boolean
  /**
   * What happens on a single tap.
   */
  onSingleTap: () => void
  /**
   * What happens on a double tap.
   * A double tap is detected when the user taps twice within 300ms.
   */
  onDoubleTap: () => void
}

//* =========================== React Component ================================

const TapOverlaySegment = ({
  flexGrow,
  onlySingleTap,
  onSingleTap,
  onDoubleTap,
}: TapRecognizerSegmentProps): JSX.Element => {
  const tapCountRef = useRef(0)
  const tapTimerIdRef = useRef<NodeJS.Timeout | undefined>()

  return (
    <Wrapper
      flexGrow={flexGrow}
      onTouchEnd={() => {
        if (onlySingleTap) {
          onSingleTap()
        } else {
          // This mechanism is to detect double taps.
          tapCountRef.current += 1

          if (tapCountRef.current == 1) {
            tapTimerIdRef.current = setTimeout(() => {
              tapCountRef.current = 0
              // Emit a single touch event.
              onSingleTap()
            }, 300)
          } else if (tapCountRef.current == 2) {
            // Cancel the timer and emit a double touch event.
            if (tapTimerIdRef.current !== undefined) {
              clearTimeout(tapTimerIdRef.current)
            }

            tapCountRef.current = 0

            if (onDoubleTap !== undefined) {
              onDoubleTap()
            }
          }
        }
      }}
    ></Wrapper>
  )
}

export default TapOverlaySegment

//* ======================== Styled Components =================================

const Wrapper = styled.div<{ flexGrow: number }>`
  flex-grow: ${(props) => props.flexGrow};
  height: 100%;
`
